import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		alignItems: 'center',
	},
	text: {
		fontSize: '14px',
		lineHeight: '1.4',
		textAlign: 'center',
		margin: 0,
	},
	button: {
		alignSelf: 'center',
	},
	buttonText: {
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
	},
	sparkleIcon: {
		color: brandPrimary,
		width: '14px',
		height: '14px',
	},
});
